import { type CSSProperties, type JSX } from 'react';
import { Link } from 'react-router';
import { type RequiredTestId } from '@common/components/controls/TestId';
import Icon, { type IconComponentType, rotateIcon } from '@common/components/Icon';
import { useCloseMenu } from '@common/components/Menu/MenuContextProvider';
import IconArrowDown from '@common/components/svgs/common/ArrowDown';
import Translated from '@common/components/Translated';
import '@common/styles/components/menu.pcss';

interface MenuNavigationOptionProps {
  id: string;
  to: Partial<Location>;
  onClick?: () => void;
  tagName?: keyof JSX.IntrinsicElements;
  style?: CSSProperties;
  leadingIcon?: IconComponentType;
  withArrow?: boolean;
}

function MenuNavigationOption({
  id,
  to,
  onClick,
  tagName = 'span',
  style,
  leadingIcon,
  withArrow,
  ...rest
}: RequiredTestId<MenuNavigationOptionProps>) {
  const closeMenu = useCloseMenu();

  return (
    <Link
      className="ph-no-capture menu__option menu__option--navigation"
      style={style}
      to={to}
      onClick={() => closeMenu(onClick)}
      {...rest}
    >
      <div className="menu__option-content">
        {leadingIcon && (
          <span className="menu__option-leading-icon">
            <Icon component={leadingIcon} />
          </span>
        )}
        <Translated id={id} tagName={tagName} />
      </div>
      {withArrow && (
        <div className="menu__option-trailing-icon">
          <Icon component={rotateIcon(IconArrowDown, -90)} />
        </div>
      )}
    </Link>
  );
}

export default MenuNavigationOption;
